module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-live-container"
  }, [_c('h2', {
    staticClass: "live-title"
  }, [_vm._v("Saya ada siaran langsung gratis")]), _vm._v(" "), (_vm.channels.length || _vm.isLoading) ? _c('ul', {
    staticClass: "channel-list"
  }, _vm._l((_vm.channels), function(channel, index) {
    return _c('li', {
      key: channel.cname,
      staticClass: "channel-item"
    }, [_c('div', {
      staticClass: "channel-info",
      on: {
        "click": function($event) {
          _vm.handleChannelClick(channel)
        }
      }
    }, [_c('img', {
      staticClass: "icon-living",
      attrs: {
        "src": require("../assets/icons/icon-living.png")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "channel-name"
    }, [_vm._v(_vm._s(channel.cname))]), _vm._v(" "), _c('img', {
      staticClass: "icon-play",
      attrs: {
        "src": require("../assets/icons/icon-left.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "channel-likes",
      on: {
        "click": function($event) {
          _vm.handleChannelLike(index)
        }
      }
    }, [(channel.like) ? _c('img', {
      staticClass: "icon-like",
      attrs: {
        "src": require("../assets/icons/icon-tread.png")
      }
    }) : _c('img', {
      staticClass: "icon-like",
      attrs: {
        "src": require("../assets/icons/icon-like.png")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "likes-count"
    }, [_vm._v(_vm._s(channel.likes))])])])
  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.channels.length) ? _c('div', {
    staticClass: "data-empty"
  }, [_vm._v("\n        Siaran langsung streaming gratis sedang dipersiapkan untuk Anda simak sebelum pertandingan dimulai!\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "add-channel-btn",
    on: {
      "click": function($event) {
        _vm.popupVisible = true
      }
    }
  }, [_c('img', {
    staticClass: "icon-plus",
    attrs: {
      "src": require("../assets/icons/icon-add.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "add-channel-text"
  }, [_vm._v("Saya ada siaran langsung gratis")])]), _vm._v(" "), _c('AppLoading', {
    attrs: {
      "loading": _vm.isLoading
    }
  }), _vm._v(" "), _c('AppLivePopup', {
    attrs: {
      "visible": _vm.popupVisible
    },
    on: {
      "close": function($event) {
        _vm.popupVisible = false
      },
      "submit": _vm.handleSubmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a188149","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/matchLive.vue
// module id = 702
// module chunks = 1